import { PaletteOptions } from "@mui/material";

export const palette: PaletteOptions = {
  background: {
    default: "#F6F4F9",
    paper: "#FFF",
  },
  primary: {
    main: "#0E378C",
    light: "#87a5e8",
    dark: "#001a67", //default
    contrastText: "#fff", //default,
  },
  secondary: {
    main: "#d7e7d3",
    light: "#ebf3e9",
    dark: "#9bc293",
    contrastText: "#fff",
  },
  error: {
    main: "#d32f2f",
    light: "#ee8375",
    dark: "#b8071c",
    contrastText: "#fff",
  },
  warning: {
    main: "#ed6c02",
    light: "#ff9800",
    dark: "#e65100",
    contrastText: "#fff",
  },
  info: {
    main: "#FFFBCC",
    light: "#fffde8",
    dark: "#f3efc5",
    contrastText: "#16171D",
  },
  success: {
    main: "#2e7d32",
    light: "#4caf50",
    dark: "#1b5e20",
    contrastText: "#fff",
  },
  text: {
    primary: "#16171D", //default
    secondary: "#45464F", //default
    disabled: "rgba(0, 0, 0, 0.8)", //default
  },
  divider: "rgba(0, 0, 0, 0.12)",
  table: {
    hover: "#0E378C14",
    selected: "#037A1714",
  },
};

declare module "@mui/material/styles" {
  interface Palette {
    table: Palette["action"];
  }

  interface PaletteOptions {
    table?: PaletteOptions["action"];
  }
}
